import { useEffect } from "react";
import fixDropDownPositionMobile from "./fixMobileMenuPosition";
import isSSR from "venuescanner-js/services/isSSR";

const findScrollingParents = (element) => {
  let parents = [];
  while (element.parentNode !== null && element.parentNode !== document.body) {
    element = element.parentNode;
    if (
      element.clientHeight !== element.scrollHeight ||
      element.clientWidth !== element.scrollWidth
    )
      parents.push(element);
  }
  return parents;
};
const useFixMobileMenuPositionOnScroll = (menuIsOpen, absolute) =>
  useEffect(() => {
    if (absolute) return;
    if (!menuIsOpen) return;
    if (isSSR()) return;
    let scrollers = [];
    setTimeout(() => {
      const menu = document.querySelector(".SelectField__menu");
      // console.log(menu)
      if (menu) {
        scrollers = findScrollingParents(menu);
        // console.log(scrollers)
        document.addEventListener("scroll", fixDropDownPositionMobile, {
          passive: true,
        });
        window.addEventListener("resize", fixDropDownPositionMobile, {
          passive: true,
        });
        window.addEventListener(
          "toggleNavbar",
          fixDropDownPositionMobile,
          false
        );
        scrollers.forEach((scroller) => {
          scroller.addEventListener("scroll", fixDropDownPositionMobile, {
            passive: true,
          });
        });
      }
    });
    return () => {
      if (typeof window === "undefined") return;
      document.removeEventListener("scroll", fixDropDownPositionMobile);
      window.removeEventListener("resize", fixDropDownPositionMobile);
      window.removeEventListener(
        "toggleNavbar",
        fixDropDownPositionMobile,
        false
      );
      scrollers.forEach((scroller) => {
        scroller.removeEventListener("scroll", fixDropDownPositionMobile);
      });
    };
  }, [absolute, menuIsOpen]);

export default useFixMobileMenuPositionOnScroll;
